module.exports = __webpack_public_path__ + "static/SNB FINANCE HOLDINGS LIMITED CUSTOMER AGREEMENT v 6.0 ND-4913d72a31c3b8163e9fc503c2c899ee.pdf";